module.exports = __webpack_public_path__ + "static/media/2-star.d2c0fb77.png";